import React, { useState, useEffect } from 'react';
import { Select, Space } from 'antd';
import CategoryServices from 'services/product_category';
import { useApp } from "contexts/app";
import _, { values } from "lodash"

const service = new CategoryServices();
const CategoryPicker = (props) => {




    const [options, setOptions] = useState([])

    useEffect(() => {
        loadData();
    }, [])

    const loadData = async () => {
        var list = await service.list();
        list = list.map(x => ({ label: x.name, value: x.id }))
        setOptions(list)
    }


    return (
        <Select
            {...props}
       
            allowClear
   

            options={options}
        />
    )


}
export default CategoryPicker;